export const DEFAULT_LOCALE = "en";

export const locales = [
  { code: "en", label: "English", ogLocale: "en_US" },
  { code: "es", label: "Español", ogLocale: "es_ES" },
  { code: "nl", label: "Nederlands", ogLocale: "nl_NL" },
  { code: "pap", label: "Papiamentu", ogLocale: "pap" }
];

export const localeCodes = locales.map((locale) => locale.code);

export function isSupportedLocale(value) {
  return localeCodes.includes(value);
}
